let currentPage = 1;
const loadMoreButton = document.getElementById('load-more');
const productGrid = document.querySelector('[id^="product-grid"]');
const loadMoreContainer = document.getElementById('load-more-container');
const totalPagesElement = document.querySelector('.pagination');
const totalPages = totalPagesElement ? parseInt(totalPagesElement.dataset.totalPages) : 1;
const sectionId = productGrid.dataset.id;

if (loadMoreButton && productGrid) {
  loadMoreButton.addEventListener('click', function () {
    currentPage += 1;
    console.log('Loading page', currentPage);

    fetch(`${window.location.pathname}?page=${currentPage}&section_id=${sectionId}`)
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        const newGrid = doc.querySelector('[id^="product-grid"]');
        if (!newGrid) {
          console.warn('New product grid not found');
          return;
        }

        const newItems = newGrid.querySelectorAll('li');
        console.log(`Found ${newItems.length} new items`);

        const existingHandles = Array.from(productGrid.querySelectorAll('li')).map(item =>
          item.getAttribute('data-product-handle')
        );

        newItems.forEach(item => {
          const handle = item.getAttribute('data-product-handle');
          if (!existingHandles.includes(handle)) {
            productGrid.appendChild(item);
          } else {
            console.log(`Skipping duplicate: ${handle}`);
          }
        });

        if (currentPage >= totalPages) {
          loadMoreContainer.style.display = 'none';
        }
      })
      .catch(error => {
        console.error('Load More error:', error);
      });
  });
}
